import { apiGet, apiPost } from "../../utils";

export function addUserAndAssignToSubAdminAPI(data) {
  return apiPost(`/api/addUserAndAssignToSubAdmin`, data);
}
